// Una liga cae en UNA de dos casas, y las casas son las mismas que las de los torneos.
//
//   MIAS       las creo el club. Existen para nombrar la competencia de afuera que no
//              esta en MYKLUBB ("Liga Municipal", "Copa Regional") al dar de alta un
//              torneo INTERNO. Se crean, se editan, se desactivan.
//
//   DE LA RED  llegan solas: son de la organizadora de un torneo de MYKLUBB Torneos al
//              que el club se inscribio o cuya invitacion acepto (eso es exactamente lo
//              que abre `_liga_lectura_permitida` en la base). El club NO las crea --
//              ya existian -- y no las toca. Solo las ve.
//
// La casa la decide `org_id`: quien la creo. No hay tercera casa.
import { MUNDO_INTERNO, MUNDO_RED } from './mundoTorneo'

export const separarLigas = (ligas, orgId) => {
  // Sin organizacion no se puede decir de quien es nada. Antes que adivinar, no se
  // reparte: una liga que no se sabe clasificar no aparece en ninguna casa.
  if (!orgId) return { mias: [], deLaRed: [] }
  const lista = Array.isArray(ligas) ? ligas.filter(Boolean) : []
  return {
    mias: lista.filter((l) => l.org_id === orgId),
    deLaRed: lista.filter((l) => l.org_id !== orgId),
  }
}

export const ligasDelMundo = (ligas, mundo, orgId) => {
  const { mias, deLaRed } = separarLigas(ligas, orgId)
  if (mundo === MUNDO_INTERNO) return mias
  if (mundo === MUNDO_RED) return deLaRed
  return []
}

// Solo en el mundo interno hay boton de crear. En la red las ligas ya existen.
export const seCreanLigasEnEsteMundo = (mundo) => mundo === MUNDO_INTERNO
